module.exports = __webpack_public_path__ + "img/modalLog.433c2c9a.png";